export const DATASET_ID_PARAM_KEY = 'id';

export const datasetsPath = () => '/settings/datasets' as const;

export const datasetTableRoute = () =>
  `/settings/datasets/:${DATASET_ID_PARAM_KEY}/details` as const;
export const datasetTablePath = (name: string) =>
  `/settings/datasets/${encodeURIComponent(name)}/details` as const;

export const datasetSettingsRoute = () =>
  `/settings/datasets/:${DATASET_ID_PARAM_KEY}/settings` as const;
export const datasetSettingsPath = (name: string) =>
  `/settings/datasets/${encodeURIComponent(name)}/settings` as const;

export const datasetCreateRoute = () => '/settings/datasets/create' as const;
export const datasetLogsRoute = () =>
  `/settings/datasets/:${DATASET_ID_PARAM_KEY}/logs` as const;
export const datasetLogsPath = (name: string) =>
  `/settings/datasets/${encodeURIComponent(name)}/logs` as const;
